import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormsModule } from '@angular/forms';

import { SharedModule } from "@bt/shared";

import { ProfileComponent } from './profile.component';
import { dirtyParentQueries } from '@angular/core/src/view/query';
import { DirectiveModule } from '@bt/directives/directive.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
    DirectiveModule
  ],
  declarations: [
    ProfileComponent
  ],
})
export class ProfileModule { }


// WEBPACK FOOTER //
// ./src/app/profile/profile.module.ts